'use client';

import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { showAppLoading } from '@/app/store/appShellSlice';
import { IconBrandGoogle } from '@tabler/icons-react';

import { Button } from '@/components/ui/button';

type GoogleLoginButtonProps = {
  className?: string;
};

const AUTH_BASE = process.env.NEXT_PUBLIC_REPAROLY_API_URL ?? 'https://api.reparoly.local';

export default function GoogleLoginButton({ className }: GoogleLoginButtonProps) {
  const dispatch = useDispatch();
  const loginUrl = useMemo(() => {
    const base = (AUTH_BASE && String(AUTH_BASE)) || 'http://localhost:4000';
    // Propaga ?next de la URL actual si existe; por defecto apunta al onboarding
    const currentNext = new URLSearchParams(window.location.search).get('next');
    const targetNext = currentNext || '/onboarding';
    const next = encodeURIComponent(
      `${window.location.origin}/auth/sso?next=${encodeURIComponent(targetNext)}`,
    );
    return `${base}/v1/auth/google/login?next=${next}`;
  }, []);

  const handleClick = () => {
    // Muestra overlay global antes de redirigir a OAuth
    (dispatch as any)(showAppLoading());
    window.location.href = loginUrl;
  };

  return (
    <Button
      type="button"
      onClick={handleClick}
      variant="outline"
      className={className || 'h-12 text-lg font-semibold'}
    >
      <IconBrandGoogle className="size-5" />
      Google
    </Button>
  );
}
